// https://fluentsite.z22.web.core.windows.net/quick-start
import {
  FluentProvider,
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  tokens,
} from "@fluentui/react-components";
import { useEffect } from "react";
import { HashRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { app } from "@microsoft/teams-js";
import * as microsoftTeams from "@microsoft/teams-js";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import { TeamsFxContext } from "./components/Context";
import config from "./components/sample/lib/config";
import Home from "./screens/Home";
import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import "./assets/Futura-Medium.otf"
import "./assets/Futura-Bold.otf"
import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";
import Login from "./screens/Login";

/**
 * The main app which handles the initialization and routing
 * of the app.
 */

const resources: Resource = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: navigator.language,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default function App() {
  const { loading, theme, themeString, teamsUserCredential } = useTeamsUserCredential({
    initiateLoginEndpoint: config.initiateLoginEndpoint!,
    clientId: config.clientId!,
  });
  useEffect(() => {
    
    loading &&
      app.initialize().then(() => {
        // Hide the loading indicator.
        app.notifySuccess();
      });
  }, [loading]);
  return (
    <TeamsFxContext.Provider value={{ theme, themeString, teamsUserCredential }}>
      <Router>
        {!loading && (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="*" element={<Navigate to={"/"} />}></Route>
          </Routes>
        )}
      </Router>
      </TeamsFxContext.Provider>
  );
}
